document.addEventListener('DOMContentLoaded', function () {
      const accordionHeaders = document.querySelectorAll('.px-accordion-header');

      accordionHeaders.forEach(header => {
        header.addEventListener('click', function () {
          const accordion = this.parentElement;
          accordion.classList.toggle('active');

          // Close other open accordions when opening a new one
          if (accordion.classList.contains('active')) {
            document.querySelectorAll('.px-accordion').forEach(item => {
              if (item !== accordion && item.classList.contains('active')) {
                item.classList.remove('active');
              }
            });
          }
        });
      });
    });